<div data-testid="view-entries-container" class="title-search-container">
  <goab-text
    data-testid="view-entries-title"
    tag="h1"
    size="heading-l"
    mt="s"
    mb="m"
  >
    {{ 'headerTitle' | res : pageId }}
  </goab-text>
</div>
<app-capacity-reporting-search></app-capacity-reporting-search>
@if(hasCapacityReports()) {
<app-capacity-reporting-grid></app-capacity-reporting-grid>
<app-capacity-reporting-modal></app-capacity-reporting-modal>
} @else {
<app-no-reports-found></app-no-reports-found>
}
